/**
 * 번역 값의 `<hl>...</hl>` 마커를 진한 semibold span 으로 변환한 HTML 문자열.
 * dangerouslySetInnerHTML 로 단일 노드 렌더링 → React 의 child tree diff 우회
 * → SSR/CSR hydration mismatch 회피.
 * 번역 값은 우리가 통제하는 정적 리소스이므로 XSS 우려 없음.
 */
export function highlightHtml(text: string): string {
  return text.replace(
    /<hl>(.*?)<\/hl>/g,
    '<span class="font-600 text-coolgray-90">$1</span>',
  );
}
